import activitiModdleDescriptor from './activitiDescriptor.json';
import flowableModdleDescriptor from './flowableDescriptor.json';
import camundaModdleDescriptor from './camundaDescriptor.json';

export default {
  activiti: activitiModdleDescriptor,
  flowable: flowableModdleDescriptor,
  camunda: camundaModdleDescriptor
}